import { useMutation } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const {
  CONTROLLERS: {
    RECEIPT: { VERSION, BASE },
  },
} = USER;

export const useUploadReceiptMutation = ({
  customerId,
  transactionId,
  formData,
  onSuccess,
  isExternal,
  accountExternalId,
  externalAccountId,
}: {
  customerId: string;
  transactionId: string;
  formData: FormData | null;
  onSuccess: (receiptPath: string) => void;
  isExternal?: boolean;
  accountExternalId?: string;
  externalAccountId?: string;
}) =>
  useMutation(
    async () => {
      const url = isExternal
        ? `${BASE_URL}/api/v1/user/${customerId}/account/${accountExternalId}/externalAccount/${externalAccountId}/transaction/${transactionId}/receipt`
        : `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${transactionId}/receipt`;

      const { data } = await httpService.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return data;
    },
    {
      onSuccess: (data) => {
        if (onSuccess) {
          onSuccess(data?.receiptPath);
        }
      },
    },
  );
